/** Botim Money wordmarks (CDN). Black asset for light surfaces; white for dark UI. */
export const BOTIM_MONEY_LOGO_BLACK =
  'https://cdn.prod.website-files.com/653cfa178eca97221b3214bf/6851471e48d39b55726b71cc_10537925169d7c042fb3683d77e8392f_botim%20money.svg'

export const BOTIM_MONEY_LOGO_WHITE =
  'https://cdn.prod.website-files.com/653cfa178eca97221b3214bf/685146e286f800017a7974a1_c4c0355e844948934b4b6da5aea0fbfc_botim%20money%20white.svg'
